import { createSelector } from 'reselect';

import {
  getRentPriceInfo,
  getSalePriceInfo,
  getSubscriptionPriceInfo,
} from '@wix/wix-vod-shared/src/common/utils/deal-info-helpers';
import { getChannelForWidget } from '@wix/wix-vod-shared/src/common/selectors/channels';

import { getVideoById } from 'shared/selectors/videos';

export function hasPaymentContent(state) {
  const channelsDealInfo = _.get(state, 'payments.channelsDealInfo');
  const videosDealInfo = _.get(state, 'payments.videosDealInfo');

  return !_.isEmpty(channelsDealInfo) || !_.isEmpty(videosDealInfo);
}

export function isPayed(entity) {
  return Boolean(_.get(entity, 'dgsInfo'));
}

export function isPaypalEnabled(state) {
  return _.get(state, 'payments.paypal.enabled', false);
}

export const getChannelDealInfo = createSelector(getChannelForWidget, _.property('dealInfo'));

export const getSubscribeInfo = createSelector(getChannelDealInfo, getSubscriptionPriceInfo);

export const getVideoDealInfo = createSelector(getVideoById, _.property('dealInfo'));

export const getRentInfo = createSelector(getVideoDealInfo, getRentPriceInfo);

export const getSaleInfo = createSelector(getVideoDealInfo, getSalePriceInfo);



// WEBPACK FOOTER //
// ./src/shared/selectors/payments.js